// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { Tab } from 'components/molecules/Tab';
import { useHistory } from 'react-router';
import AdminTenantManagement from '../AdminTenantManagement';
import CustomizeListCategory from '../CustomizeListCategory';
import { CustomizeItemBreadcrumbs } from 'util/Types';
import styles from './EmissionSiteDetailManagement.module.scss';
import TemporaryStorageManagement from '../TemporaryStorageManagement';

type EmissionSiteDetailManagementProps = {
  onSetBreadcrumb: (breadcrumb: CustomizeItemBreadcrumbs) => void;
  showTemporaryStorage?: boolean;
};

const EmissionSiteDetailManagement: React.FC<
  EmissionSiteDetailManagementProps
> = ({ onSetBreadcrumb: setBreadcrumb, showTemporaryStorage }) => {
  const history = useHistory();

  const titleCustomize = {
    0: 'テナント一覧',
    1: '品目カテゴリ一覧画面',
    ...(showTemporaryStorage && { 2: '一時保管場所設定' }),
  };

  const tabItems = [
    'テナント設定',
    '品目設定',
    ...(showTemporaryStorage ? ['一時保管場所設定'] : []),
  ];

  return (
    <Tab
      className={styles.tabAdminCustomize}
      tabItems={tabItems}
      defaultTabIndex={parseInt(history.location.hash.replace('#', ''))}
      renderContent={({ index }) => (
        <div>
          <h4 className={styles.titleCustomize}>{titleCustomize[index]}</h4>
          {index === 0 && (
            <AdminTenantManagement
              onSetBreadcrumb={(operatorName, siteName) => {
                setBreadcrumb({ operatorName, siteName });
              }}
            />
          )}
          {index === 1 && (
            <CustomizeListCategory
              onSetBreadcrumb={(operatorName, siteName) => {
                setBreadcrumb({ operatorName, siteName });
              }}
            />
          )}
          {showTemporaryStorage && index === 2 && (
            <TemporaryStorageManagement
              onSetBreadcrumb={(operatorName, siteName) => {
                setBreadcrumb({ operatorName, siteName });
              }}
            />
          )}
        </div>
      )}
    />
  );
};

export default EmissionSiteDetailManagement;
